import React, { type ErrorInfo, type ReactNode } from "react";
import ErrorScreen from "./ErrorScreen";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

class AppErrorBoundary extends React.Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("AppErrorBoundary capturó un error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorScreen
          title="Ha ocurrido un error"
          description="No se ha podido cargar la página correctamente. Intenta volver a cargar la aplicación."
        />
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
